import React from "react"

import Style from "./index.module.sass"

function ServiceSectionBox(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    section,
    onClick
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------


  // -------------------------------------

  return (
    <div onClick={() => onClick(section.id)} className={`${Style.sectionBoxContainer} col-sm-3 col-xs-4`}>
      <div className={Style.sectionBox}>
        <div className={Style.sectionImage}>
          {
            section.image_url ? <img src={section.image_url} alt={"Copertina " + section.title}/> :
              <i className={"fal fa-box-full"}/>
          }

        </div>

        <div className={Style.sectionTitle}>
          {section.title}
        </div>
      </div>
    </div>)
}

export default ServiceSectionBox
